<template>
  <div class="modify-save-search">
    <button
      class="modify"
      @click="$emit('modify-search')"
    >
      > Modifier la recherche
    </button>
    <button
      class="save"
      @click="saveSearch()"
    >
      Enregistrer la recherche
    </button>

    <advanced-search-save-modal :type="type"></advanced-search-save-modal>
  </div>
</template>

<script>
import AdvancedSearchSaveModal from '@/components/AdvancedSearchSaveModal'

export default {
  name: 'AdvancedSearchModifySaveBar',
  components: { AdvancedSearchSaveModal },

  props: {
    type: String
  },

  methods: {
    saveSearch () {
      this.$modal.show('advancedSearchSaveModal')
    }
  }
}
</script>
